import React from 'react';
import { WrappedButton } from '../button';

const Footer = ({
	primary,
	secondary,
	backAction = null,
	children = null,
	className = '',
}) => (
	<div className={`common-ui-layout-footer ${className}`}>
		{backAction && (
			<WrappedButton
				buttonType="tertiary-ghost"
				label="Back"
				onClick={backAction}
				dataqa="back-button"
				icon={
					<div
						className="common-ui-back-icon"
						role="img"
						aria-label="Back button"
						aria-live="polite"
					/>
				}
			/>
		)}
		{children && <div className="content-container">{children}</div>}
		{(primary || secondary) && (
			<div className="button-container">
				{secondary && (
					<WrappedButton buttonType="tertiary-ghost" {...secondary} />
				)}
				{primary && <WrappedButton buttonType="primary" {...primary} />}
			</div>
		)}
	</div>
);

export default Footer;
